import React from 'react';

const EyeIcon = ({ fill = "currentColor", className = "bi bi-eye-fill", width = "16", height = "16", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} className={className} viewBox="0 0 16 16" {...props}>
        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    </svg>
);

export default EyeIcon;